import cn from 'clsx';
import type {ComponentPropsWithoutRef, ElementType} from 'react';

interface GradientBorderCardProps extends ComponentPropsWithoutRef<'button'> {
    /** `button` when the card itself is the click target. */
    as?: ElementType;
    fillColor: string;
    borderGradient: string;
}

const GradientBorderCard = ({
    as: Tag = 'div',
    fillColor,
    borderGradient,
    className,
    style,
    children,
    ...rest
}: GradientBorderCardProps) => {
    return (
        <Tag
            className={cn('border-2 border-transparent', className)}
            style={{
                background: `linear-gradient(${fillColor}, ${fillColor}) padding-box, ${borderGradient} border-box`,
                ...style,
            }}
            {...rest}
        >
            {children}
        </Tag>
    );
};

export default GradientBorderCard;
